declare const I18n;

import React, { useState, useEffect } from "react";
import Header from "../Header";
import AchievementTabs from "./components/AchievementTabs";
import BadgeIndex from "./badges";
import OverallRankIndex from "./badges/overallrank";

type AchievementsProps = {
  groupedBadges: any;
  overallRanks: any
};

const Achievements: React.FC<AchievementsProps> = ({ groupedBadges, overallRanks }) => {

  const params = new URLSearchParams(window.location.search);
  const initialTab = params.get("tab") || "badge";

  const [currentTab, setCurrentTab] = useState(initialTab);

  useEffect(() => {
    if (params.has("tab")) {
      const url = new URL(window.location.href);
      url.searchParams.delete("tab");
      window.history.replaceState({}, "", url.toString());
    }
  }, []);

  return (
    <div>
      <Header title={I18n.t("views.nav.achievements")} showIcon={false} />

      <AchievementTabs currentTab={currentTab} setCurrentTab={setCurrentTab} />

      {currentTab === "badge" && (
          <BadgeIndex groupedBadges={groupedBadges} />
      )}

      {currentTab === "ranks" && (
        <div>
          <OverallRankIndex overallRanks={overallRanks}/>
        </div>
      )}
    </div>
  );
};

export default Achievements;
